import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { BasePage, PageType } from 'src/components/BasePage';
import { handleStartProcessCustomEvent } from 'src/components/EntityPresentation/utils/handleStartProcessCustomEvent';
import { FormioForm } from 'src/components/FormioForm/FormioForm';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { FormioCustomEvent } from 'src/core/Formio.types';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { Entity } from 'src/utils/mobx/BasicStore/BasicStore.types';

type CustomFormPageProps = {
    pageName: string;
    store: BasicStore<Entity>;
    baseUrl: string;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onCustomEvent?: (event: FormioCustomEvent) => Promise<any>;
};

export const CustomFormPage = observer(
    ({
        pageName,
        store,
        baseUrl,
        onCustomEvent,
        ...props
    }: CustomFormPageProps) => {
        useEffect(() => {
            store.loadForm(store.customFormKey);

            return () => {
                store.formLoader.reset();
            };
        }, []);

        if (store.formLoader.isLoading) {
            return <SpinnerFullWidth />;
        }

        return (
            <BasePage pageName={pageName} type={PageType.FULL} {...props}>
                <FormioForm
                    form={store.currentItemForm!}
                    onCustomEvent={(event) => {
                        if (onCustomEvent) {
                            return onCustomEvent(event);
                        }
                        if (event.type === 'startProcess') {
                            handleStartProcessCustomEvent(event, baseUrl);
                        }

                        return Promise.resolve();
                    }}
                />
            </BasePage>
        );
    },
);
